import { useEffect } from 'react'
import { useReactiveVar } from '@apollo/client'
import { IProject } from 'shared/interfaces'
import { activeProjectVar } from 'modulesCommon/store'
import { useCountCampaignView } from 'modulesCommon/graphql/mutations/countCampaignViews'

const useSpaceProjectViews = () => {
  const activeProject = useReactiveVar<Omit<IProject, 'artist'>>(activeProjectVar)

  const { mutate: countCampaignView } = useCountCampaignView()
  useEffect(() => {
    if (activeProject?.id) {
      countCampaignView({ variables: { input: { campaign_id: activeProject?.id } } })
    }
    return () => {
    }
  }, [activeProject?.id, countCampaignView])

  return {}
}

export default useSpaceProjectViews
